import React from 'react'
import { useTranslation } from 'react-i18next'
import { ConfirmDialog } from '../common/ConfirmDialog'

interface LogoutConfirmDialogProps {
    open: boolean
    onClose: () => void
    onConfirm: () => void
    pending: boolean
}

export const LogoutConfirmDialog: React.FC<LogoutConfirmDialogProps> = ({ open, onClose, onConfirm, pending }) => {
    const { t } = useTranslation()
    return (
        <ConfirmDialog
            open={open}
            title={t('encounter.logout_confirm_title')}
            body={t('encounter.logout_confirm_body')}
            cancelLabel={t('encounter.cancel')}
            confirmLabel={t('encounter.logout_confirm')}
            onClose={onClose}
            onConfirm={onConfirm}
            pending={pending}
        />
    )
}
